import React from "react";
import { Container, Row, Col } from "react-bootstrap"
import PanelWrapper from "../../internal/panelWrapper/PanelWrapper";
import "./SingleColumnGeneralPanel.scss";
import {
  BackgroundKeyToColor,
  // GeneralSizeKeyToPaddingNumber,
  // GeneralHeightKeyToBarHeight,
} from "../../../utils/datasources"
import { resolveRichText } from "../../../utils/richText";
import Buttons from "../../internal/buttons/Buttons";
import ModalHelper from "../../../utils/modalHelper";
const SingleColumnGeneralPanel = (blok) => {
    const {
        content,
        cta_text,
        cta_link,
        cta_color,
        is_modal,
        modal_id,
        cta_type,
        modal
    } = blok.blok;

    const buttonProps = {
        text: cta_text,
        url: cta_link,
        isModal: is_modal,
        modalId: modal_id,
        component: cta_type,
        textColor: cta_color,
        modal: modal,
        cta_type: cta_type
      }
    return (
        <PanelWrapper blok={blok.blok}>
            <Container className="single-column-general-panel">
                <Row>
                    <Col className="justify-content-center">
                        <div dangerouslySetInnerHTML={resolveRichText(content)}></div>
                        {cta_text && cta_text !== "" ? <div className="general-button-wrapper">
                            {is_modal ? <ModalHelper buttonProps={buttonProps} /> : <Buttons buttonProps={buttonProps} />}
                            </div> : null}
                    </Col>
                </Row>
            </Container>
        </PanelWrapper>
    )
}

export default SingleColumnGeneralPanel;
